import { Service } from '@genial/services';
import { selectorFamily } from 'recoil';

import { screenName } from '../constants';
import {
  normalizeFundsWithdrawDateQuotation,
  normalizeFundsWithdrawGetFundAsset,
  normalizeFundsWithdrawSimulateTax,
} from '../normalize';
import {
  FundWithdrawAssetNormalized,
  FundWithdrawDateQuotationNormalized,
  FundWithdrawTaxSimulateNormalized,
} from '../types';

export const fundsWithdrawGetFundAsset = selectorFamily<
  FundWithdrawAssetNormalized | null | undefined,
  { accountId: number; fundId: number }
>({
  key: 'redemptionSolicitation/fundsWithdrawGetFundAsset',
  get: ({ accountId, fundId }) => {
    return async () => {
      const { data } = await Service.Fund.V1.getWithdrawByFundAssetsAccountId({
        accountId,
        screenName,
        productId: fundId,
      });

      if (!data) {
        throw new Error('Ocorreu um erro ao carregar os dados do fundo');
      }

      const normalizedData = normalizeFundsWithdrawGetFundAsset(data);

      return normalizedData;
    };
  },
});

export const fundsWithdrawSimulateTax = selectorFamily<
  FundWithdrawTaxSimulateNormalized | null | undefined,
  { portfolioId: number; fundId: number; value: number }
>({
  key: 'redemptionSolicitation/fundsWithdrawSimulateTax',
  get: ({ fundId, portfolioId, value }) => {
    return async () => {
      try {
        const { data } = await Service.Fund.V1.getWithdrawSimulateTax({
          fundId,
          portfolioId,
          screenName,
          value,
        });

        const normalizedData = normalizeFundsWithdrawSimulateTax(data);

        return normalizedData;
      } catch (_error) {
        return {
          irValueNormalized: '--',
          iofValueNormalized: '--',
          penaltyValueNormalized: '--',
          liquidityValueNormalized: '--',
          iofValue: 0,
          irValue: 0,
          penaltyValue: 0,
          liquidityValue: 0,
          isBalanceAvailable: false,
        };
      }
    };
  },
});

export const fundsWithdrawDateQuotation = selectorFamily<
  FundWithdrawDateQuotationNormalized | null | undefined,
  { date: Date; totalValueOption: boolean; productId: number; accountId: number }
>({
  key: 'redemptionSolicitation/fundsWithdrawDateQuotation',
  get: ({ date, totalValueOption, productId, accountId }) => {
    return async () => {
      const { data } = await Service.Fund.V1.postWithdrawDateQuotation({
        screenName,
        fundWithdrawDateQuotationRequest: {
          currentDateTime: date,
          isRedemptionAnticipated: false,
          movimentType: totalValueOption ? 'TotalRedemption' : 'GrossRedemption',
          productId: `${productId}`,
          accountId,
        },
      });

      const normalizedData = normalizeFundsWithdrawDateQuotation(data);

      return normalizedData;
    };
  },
});
